// removed by extract-text-webpack-plugin
module.exports = {"container":"PartialPayoutPopup__container__S2E2F","popupBox":"PartialPayoutPopup__popupBox__HWDlX","title":"PartialPayoutPopup__title__3nSOY","summaryRow":"PartialPayoutPopup__summaryRow__2BEIh","infoRow":"PartialPayoutPopup__infoRow__3alB_","baseBtn":"PartialPayoutPopup__baseBtn__1fNPU","btnCancel":"PartialPayoutPopup__btnCancel__2Yr3x","instructions":"PartialPayoutPopup__instructions__3cvtP","txtBetAmount":"PartialPayoutPopup__txtBetAmount__2V1L0","remark":"PartialPayoutPopup__remark__1ie9h","payoutCounter":"PartialPayoutPopup__payoutCounter__3cy28"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/PartialPayoutPopup/PartialPayoutPopup.css
// module id = 555
// module chunks = 0